import { BenefitDocumentDto, EmployerDocumentDto } from '@zorro/clients';
import { Space, Stack, Text, brand } from '@zorro/web/design-system';
import { useMonolithMutation } from '@zorro/web/ui-utils';
import _noop from 'lodash/noop';

import { ModalFooter } from '../ModalComponents';

export type DeleteDocumentConfirmationFormProps = {
  onClose?: () => void;
  onSubmit?: () => void;
  selectedDocument?: EmployerDocumentDto | BenefitDocumentDto;
  employerId?: string;
  isBenefitDocument?: boolean;
};

const DeleteDocumentConfirmationForm = ({
  selectedDocument,
  employerId,
  onClose = _noop,
  onSubmit = _noop,
  isBenefitDocument = false,
}: DeleteDocumentConfirmationFormProps) => {
  const { mutate: removeBenefitDocumentMutation } = useMonolithMutation({
    method: 'benefitDocumentsControllerRemoveBenefitDocument',
    successMessage: 'Document deleted',
  });

  const { mutate: deleteDocumentMutation } = useMonolithMutation({
    method: 'employerDocumentControllerDeleteDocument',
    successMessage: 'Document deleted!',
  });
  const documentName = selectedDocument?.fileName || null;

  const deleteBenefitDocument = async () => {
    if (selectedDocument) {
      await removeBenefitDocumentMutation([selectedDocument.id]);
    }
  };

  const deleteDocument = async () => {
    if (selectedDocument && employerId) {
      await deleteDocumentMutation([employerId, selectedDocument.id]);
    }
  };

  const handleSubmit = async () => {
    if (isBenefitDocument) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      deleteBenefitDocument();
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    deleteDocument();
    onSubmit();
  };

  return (
    <Stack>
      <Text fw={500}>
        Are you sure you want to delete this document?
        <Space h="xs" />
        <Text
          fw={500}
          c={brand.zorroGray400}
          style={{
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          {documentName}
        </Text>
      </Text>
      <Space h="xl" />
      <ModalFooter
        submitText="Delete document"
        submitVariant="negative"
        onSubmit={handleSubmit}
        onClose={onClose}
      />
    </Stack>
  );
};

export { DeleteDocumentConfirmationForm };
